import { gql } from '@apollo/client';
import Fragments from './fragments';

export const REQUIRED_DOCUMENT_QUERY = gql`
  query requiredDocument($id: Int!) {
    requiredDocument(id: $id) {
      ...requiredDocumentItem
    }
  }
  ${Fragments.requiredDocumentItem}
`;
